module.exports = __webpack_public_path__ + "img/4_18.2c2feb82.png";